const challenges = [
  {
    label: 'Exemplo - 2 movimentos',
    puzzle: [
      ['1', '2', '3'],
      ['4', '', '5'],
      ['7', '8', '6']
    ]
  },
  {
    label: 'Exemplo - 6 movimentos',
    puzzle: [
      ['1', '6', '2'],
      ['4', '', '3'],
      ['7', '5', '8']
    ]
  },
  {
    label: 'Exemplo - 9 movimentos',
    puzzle: [
      ['1', '8', '2'],
      ['', '4', '3'],
      ['7', '6', '5']
    ]
  },
  {
    label: 'Exemplo - 11 movimentos',
    puzzle: [
      ['1', '2', '3'],
      ['', '6', '4'],
      ['7', '8', '5']
    ]
  },
  {
    label: 'Exemplo - 17 movimentos',
    puzzle: [
      ['4', '1', '2'],
      ['', '8', '7'],
      ['6', '3', '5']
    ]
  },
  {
    label: 'Exemplo - 22 movimentos',
    puzzle: [
      ['', '1', '2'],
      ['3', '4', '5'],
      ['6', '7', '8']
    ]
  },
  {
    label: 'Exemplo - 24 movimentos',
    puzzle: [
      ['6', '5', '1'],
      ['3', '', '8'],
      ['2', '7', '4']
    ]
  },
  {
    label: 'Exemplo - 27 movimentos',
    puzzle: [
      ['4', '7', '5'],
      ['', '2', '1'],
      ['3', '6', '8']
    ]
  },
  {
    label: 'Exemplo - 31 movimentos (A)',
    puzzle: [
      ['6', '4', '7'],
      ['8', '5', ''],
      ['3', '2', '1']
    ]
  },
  {
    label: 'Exemplo - 31 movimentos (B)',
    puzzle: [
      ['8', '6', '7'],
      ['2', '5', '4'],
      ['3', '', '1']
    ]
  }
]

export default challenges
